module.exports = __webpack_public_path__ + "static/img/1-0.4a7fd2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/1-0.png
// module id = 1305
// module chunks = 0